<template>
  <div class="evalute">
    <a-spin tip="loading" v-if="loading" id="loading" size="large">
      <div class="spin-content"></div>
    </a-spin>
    <div v-else>
      <div :class="is_commented != 0 ? 'evalute-bg' : ''">
        <header v-if="is_webview == 0">
          <a-row class="header">
            <a-col :span="3" class="header-right">
              <i @click="$router.go(-1)"></i>
            </a-col>
            <a-col :span="18" class="header-title">
              <span>{{ $t("faceCourse.LecturerEvaluation") }}</span>
            </a-col>
          </a-row>
        </header>
        <!-- 未评价 -->
        <div v-if="is_commented == 0">
          <div v-for="(data, index) in datas" :key="index">
            <div class="evalute-row">
              <div class="evalute-header">
                <img
                  :src="data.head_img != '' ? data.head_img : defaultImg"
                  alt
                  :onerror="errorImg"
                />
                <h1 v-if="$i18n.locale == 'zh'">
                  我对
                  <span
                    v-text="
                      data.teacher_display_name != ''
                        ? data.teacher_display_name
                        : data.teacher_name
                    "
                  ></span
                  >的评价
                </h1>
                <h1 v-else>
                  {{ $t("faceCourse.MyCommentOn") }}
                  <span
                    v-text="
                      data.teacher_display_name != ''
                        ? data.teacher_display_name
                        : data.teacher_name
                    "
                  ></span>
                </h1>
                <a-rate
                  allowHalf
                  :style="starStyle"
                  v-model="star_num[index]"
                ></a-rate>
              </div>
              <a-textarea
                :placeholder="$t('faceCourse.LeaveAComment')"
                :rows="6"
                class="inpt-evalute"
              />
            </div>
            <div class="line"></div>
          </div>
          <div class="bottom-pos">
            <div class="evalute-bottom">
              <button @click="sub_teacher">
                {{ $t("faceCourse.Submit") }}
              </button>
            </div>
          </div>
        </div>
        <!-- 已评价 -->
        <div v-else>
          <div v-for="(data, index) in datas" :key="index">
            <div class="evalute-row">
              <div class="evalute-header">
                <img
                  :src="data.head_img != '' ? data.head_img : defaultImg"
                  alt
                  :onerror="errorImg"
                />
                <h1 v-if="$i18n.locale == 'zh'">
                  我对
                  <span
                    v-text="
                      data.teacher_display_name != ''
                        ? data.teacher_display_name
                        : data.teacher_name
                    "
                  ></span
                  >的评价
                </h1>
                <h1 v-else>
                  {{ $t("faceCourse.MyCommentOn") }}
                  <span
                    v-text="
                      data.teacher_display_name != ''
                        ? data.teacher_display_name
                        : data.teacher_name
                    "
                  ></span>
                </h1>
                <a-rate
                  allowHalf
                  :style="starStyle"
                  :value="data.score / 2"
                ></a-rate>
              </div>
              <p>{{ data.info }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import defaultImg from "../../assets/img/learning_camp/basic_fc.png";
export default {
  data() {
    return {
      defaultImg,
      errorImg:
        'this.src="' + require("@/assets/img/learning_camp/basic_fc.png") + '"',
      loading: true,
      starStyle: {
        fontSize: "0.3rem",
        color: "#f75d5d",
      },
      datas: [],
      star_num: [],
      is_commented: 0, //是否评价完成
      submit: true,
      is_webview: this.$route.query.is_webview == undefined ? 0 : 1,
    };
  },
  created() {
    // this.$i18n.locale = "zh";
    this.get_teacher();
  },
  mounted() {
    // document.title = this.$t("public.Evaluate_the_instructor");
  },
  methods: {
    get_teacher() {
      var url = "index.php/mobile/facelesson/comment-teacher-list";
      var params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: localStorage.getItem("_sys_id"),
        language: localStorage.getItem("_user_data_language"),
        trainplan_id: this.$route.query.tid,
        face_lesson_id: this.$route.query.rid, //1679//1784
      };
      this.$axios.post(url, params).then((res) => {
        this.loading = false;
        if (res.data.code == 0) {
          this.datas = res.data.result.list;
          this.is_commented = res.data.result.list[0].is_commented;
          for (var i = 0; i < this.datas.length; i++) {
            this.star_num = this.star_num.concat(4);
          }
        } else {
          if (res.data.code == 10600) {
            this.$router.push({ name: "Login" });
          } else {
            this.$toast(res.data.msg);
          }
        }
      });
    },
    sub_teacher() {
      var _c = [];
      for (var i = 0; i < this.datas.length; i++) {
        if (this.star_num[i] == 0) {
          this.$toast(this.$t("faceCourse.NoZero"));
          return;
        }
        _c[i] = {
          teacher_id: this.datas[i].teacher_id,
          score: this.star_num[i] * 2,
          info: $(".inpt-evalute").eq(i).val(),
        };
      }
      if (this.submit) {
        this.submit = false;
        var url = "index.php/mobile/facelesson/batch-teacher-comment";
        var params = {
          user_id: localStorage.getItem("_user_data_id"),
          company_id: localStorage.getItem("_user_data_company_id"),
          sso_token: localStorage.getItem("_user_data_sso_token"),
          sys_id: localStorage.getItem("_sys_id"),
          language: localStorage.getItem("_user_data_language"),
          trainplan_id: this.$route.query.tid,
          face_lesson_id: this.$route.query.rid,
          comments: _c,
        };
        this.$axios.post(url, params).then((res) => {
          if (res.data.code == 0) {
            this.$toast(this.$t("faceCourse.success"));
            setTimeout(() => {
              this.$router.go(-1);
            }, 1000);
          } else {
            if (res.data.code == 10600) {
              this.$router.push({ name: "Login" });
            } else {
              this.$toast(res.data.msg);
            }
          }
        });
      }
    },
  },
};
</script>
<style scoped lang="less">
.evalute {
  width: 100%;
  height: 100%;
  background: #eee;
  margin-bottom: 1.2rem; //底部固定高度
}
.evalute-bg {
  background: #fff;
}
header {
  height: 0.7rem;
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 7;
  width: 100%;
  padding: 0.1rem 0.3rem;
  background: #f6f6f6;
  border-bottom: 0.01rem solid #ddd;
  display: flex;
  align-items: center;
  .header-title {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-size: 0.32rem;
      color: #252631;
    }
    i {
      display: inline-block;
      width: 0.22rem;
      height: 0.03rem;
      background: #999999;
      margin: 0 0.1rem;
    }
  }
  .header-right {
    display: flex;
    align-items: center;
    i {
      display: inline-block;
      width: 0.18rem;
      height: 0.34rem;
      background: url("../../assets/img/facecourse/back.png") no-repeat
        center/contain;
      background-size: 100%;
    }
  }
}
.line {
  height: 0.2rem;
  background: #eee;
}
.evalute {
  height: 100%;
}
.evalute-row {
  padding: 0.3rem 0.4rem;
  background: #fff;
  .evalute-header {
    display: flex;
    align-items: center;
    img {
      width: 0.8rem;
      height: 0.8rem;
      border-radius: 50%;
      pointer-events: none; //防止图片点击放大
    }
    h1 {
      flex-basis: 4rem;
      font-size: 0.26rem;
      padding-left: 0.1rem;
      span {
        color: #00568b;
      }
    }
  }
  .inpt-evalute {
    margin-top: 0.2rem;
    font-size: 0.26rem;
  }
  p {
    //评价完成的显示
    font-size: 0.26rem;
    padding-bottom: 0.3rem;
    border-bottom: 1px solid #ddd;
  }
}
.bottom-pos {
  .evalute-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1.2rem;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    button {
      width: 5rem;
      height: 0.78rem;
      background: #00568b;
      border: none;
      border-radius: 0.05rem;
      color: #fff;
      font-size: 0.3rem;
    }
  }
}
</style>
